import { createConnectTransport } from '@connectrpc/connect-web';

// Shared Connect transport for all CDA calls. Every RPC we use is declared
// NO_SIDE_EFFECTS, so useHttpGet keeps requests as cacheable GETs
// (?encoding=json&message=...), matching the previous hand-rolled fetch calls.
export const cdaTransport = createConnectTransport({
  baseUrl: 'https://cda.mottostreaming.com',
  useHttpGet: true,
  jsonOptions: { ignoreUnknownFields: true },
});

export const authHeaders = (publicKey: string, mottoToken?: string): HeadersInit => ({
  Authorization: `Bearer ${publicKey}`,
  ...(mottoToken ? { 'x-motto-token': mottoToken } : {}),
});
